import React, { Component } from "react";
import TabbedInstructionHeader from "./TabbedInstructionHeader";
import PatternPairs from "./PatternPairs";
import * as pageData from "./PageData";

/* eslint-disable no-unused-vars */
const tryButton = 1;
const practice = 2;
const completed = 3;
/* eslint-enable */

const pairsNeeded = 20;
var timerIndex = 0;
var myVar = null;

var completionText;

export default class SustainedAttentionInstruction extends Component {
    constructor(props) {
        super(props);
        completionText = pageData.getStandardPracticeCompletedText();
        this.circleClick = this.circleClick.bind(this);
        this.buttonClick = this.buttonClick.bind(this);
        this.state = {
            innerStep: tryButton,
            pairIndex: -1
        };
    }

    componentWillUnmount() {
        clearTimeout(myVar);
    }

    circleClick(tabId) {
        if (!this.props.waitingForSpeech) {
            this.props.setCurrentTab(tabId);
        }
    }

    setShape() {
        try {
            if (timerIndex < pairsNeeded) {
                this.setState({ innerStep: practice, pairIndex: timerIndex });
            } else {
                clearTimeout(myVar);
                myVar = null;
                this.props.clearDisableNext();
                this.setState({ innerStep: completed });
                this.props.playSpeechForInstructionEnd(completionText);
            }

            timerIndex++;
        } catch (e) {
            clearTimeout(myVar);
            myVar = null;
        }
    }

    buttonClick(type) {
        if (type === "try") {
            myVar = setInterval(this.setShape.bind(this), this.props.devMode ? 500 : 1500);
        }
    }

    render() {
        const p = this.props;

        return (
<div className="test-page-content-inner test-page-instruction test-page-sustained-sustained-instruction" >
    <TabbedInstructionHeader currentTabId={p.currentTabId} elems={p.content.elems[0].elems} circleClick={this.circleClick} />
    <div className="practice-content">
        {renderPractice(p, this.state, this.buttonClick)}
    </div>
</div>
        );
    }
}

function renderPractice(props, state, buttonClick) {
    if (state.innerStep >= completed) {
        var inner = completionText.map(function (str, index) {
            return (<p key={index + 1}>{str}</p>);
        });

        return (
        <div className="practice-completed">
            <i key="0" className="far fa-check"></i>
            {inner}
        </div>
);
    }

    return (
        <div className="practice-content-inner">
            <div className="practice-col-1">
                <PatternPairs pairsNeeded={pairsNeeded} pairIndex={state.pairIndex} />
            </div>
            <div className="practice-col-2">
                {renderPracticeButtons(props, state, buttonClick)}
            </div>
        </div>
    );
}

function renderPracticeButtons(props, state, buttonClick) {
    if (state.innerStep === tryButton) {
        return renderTryButton(props, state, buttonClick);
    }

    if (state.innerStep === practice) {
        return renderSameButton(props);
    }

    return null;
}

function renderTryButton(props, state, buttonClick) {
    const disabled = props.waitingForSpeech ? "disabled" : "";
    const label = state.innerStep === 1 ? "TRY" : "TRY AGAIN";
    return (
        <button className="btn btn-secondary btn-try" onClick={() => buttonClick("try")} disabled={disabled}>{label}</button>
    );
}

function renderSameButton(props) {
    const disabled = props.waitingForSpeech ? "disabled" : "";
    return (
    <button className="btn btn-same" disabled={disabled}>SAME</button>
    );
}